import axios from 'axios';


const API_BASE_URL = process.env.REACT_APP_API_URL;


export const loginAdmin = async (email, password) => {
  const response = await axios.post(`${API_BASE_URL}/api/auth/admin/login`, { email, password });
  return response.data;
};


export const forgotPassword = async (email) => {
  const response = await axios.post(`${API_BASE_URL}/api/auth/forgot-password`, { email });
  return response.data;
};

// Role-based access control functions
export const getCurrentUser = () => {
  try {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  } catch (error) {
    console.error('Error parsing user data from localStorage:', error);
    return null;
  }
};

export const getUserRole = () => {
  const user = getCurrentUser();
  return user?.role || null;
};

export const isAdmin = () => {
  const role = getUserRole();
  return role === 'admin';
};

export const isEventManager = () => {
  const role = getUserRole();
  return role === 'eventmanager';
};

export const hasAccess = (allowedRoles) => {
  const userRole = getUserRole();
  if (!userRole) return false;
  return allowedRoles.includes(userRole);
};

export const logout = () => {
  localStorage.removeItem('adminToken');
  localStorage.removeItem('user');
};